function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FE5196"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F77062"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "-65.211%",
  x2: "167.994%",
  y1: "20.298%",
  y2: "20.298%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FF954A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF4CC7"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M144.766 0h196.468C421.186 0 486 64.837 486 144.817v191.366C486 416.163 421.186 481 341.234 481H144.766C64.814 481 0 416.163 0 336.183V144.817C0 64.837 64.814 0 144.766 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M144.766 0h196.468C421.186 0 486 64.837 486 144.817v191.366C486 416.163 421.186 481 341.234 481H144.766C64.814 481 0 416.163 0 336.183V144.817C0 64.837 64.814 0 144.766 0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M167.594 135.445s111.552-8.506 111.552 91.027-29.487 119.495-55.334 125.786c0 0 107.505 26.746 107.505-113.204s-137.093-119.812-163.723-103.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.57 303.518s-11.255 36.946-45.344 41.614c-34.089 4.67-40.43-12.763-64.117-11.554-.546-4.788.974-9.582 4.216-13.303 3.243-3.721 7.936-6.056 13.024-6.48 19.2-2.451 55.176 2.318 79.078-11.923 0 0 14.248-6.986 16.92-10.378l-3.776 12.024z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.594 144.952v163.291a31.775 31.775 0 013.417-.687 179.493 179.493 0 0119.443-.996c6.834 0 14.146-.275 21.527-.961v-54.946c0-18.27-1.162-36.916 0-55.151 1.24-11.013 8.45-20.428 18.725-24.451a30.615 30.615 0 0125.046 1.648c-25.683-18.475-56.577-28.199-88.158-27.747z"
})));

function SvgDokan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486 481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDokan);
export default __webpack_public_path__ + "static/media/dokan.1943f8be.svg";
export { ForwardRef as ReactComponent };